import {
    Message
} from "element-ui";
import {
    sendAllReportByEmail,
    editSubscription,
    getInfo
} from "../../../api/suitability";
const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;

const setNameAndValue=componentsCommon.localStorage.setNameAndValue;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;

export const frequencyConfig = {
    data() {
        return {
            emailInput: "",
            emailsParagraph: [],
            emailInputMonthly: "",
            emailsParagraphMonthly: [],
            selectFrequency: [],
            radioRiskExcelChangedOnly: "false",
            companyRiskAlertAvailable: "false",
            companyRiskAlert: 0,
            configResendNeeded : true,
            radioThreeDimensions: "false",
            radioHighestRisk: "false",
            radioRemoveEndFund: "false",
        };
    },
    methods: {
        handleSubscriptionData() {
            const self = this;
            self.configSendDialogVisible = true;
            if(self.configResendNeeded) {
                self.dialogLoading = true;
                self.fillConfigData();
                self.configResendNeeded = false;
            }
        },
        fillConfigData() {
            const self = this;
            getInfo()
            .then((response) => {
                let result = response.data;
                if (result == undefined) {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000,
                    });
                    Message.close = function() {};
                } else {
                    if (checkResponseStatus(result, self)) {
                        self.emailsParagraph = result.data.subscription;
                        self.selectFrequency = result.data.frequency;
                        self.myListCompany = result.data.myListCompany;
                        if (result.data.riskExcelChangedOnly) {
                            self.radioRiskExcelChangedOnly = result.data.riskExcelChangedOnly;
                        } else {
                            self.radioRiskExcelChangedOnly = "false";
                        }
                        self.companyRiskAlert = result.data.companyRiskAlert;
                        self.notificationVisible = self.companyRiskAlert !=0 && self.companyRiskAlert !=1;
                        self.companyRiskAlertAvailable = result.data.companyRiskAlert !=0;
                        self.configResendNeeded = false;
                        if (result.data.threeDimensions) {
                            self.radioThreeDimensions = result.data.threeDimensions;
                        } else {
                            self.radioThreeDimensions = "false";
                        }
                        if (result.data.highestRisk) {
                            self.radioHighestRisk = result.data.highestRisk;                            
                        } else {
                            self.radioHighestRisk = "false";                            
                        }
                        if (result.data.endFund) {
                            self.radioRemoveEndFund = result.data.endFund;                            
                        } else {
                            self.radioRemoveEndFund = "false";                            
                        }
                    }
                }
            })
            .catch((err) => {
                Message({
                    message: "数据异常，请尝试刷新再试！",
                    type: "error",
                    duration: 2 * 1000,
                });
                Message.close = function() {};
            })
            .finally((r) => {
                self.dialogLoading = false;
            });
        },
        handleConfigFrequency() {
            const self = this;
            self.configSendDialogVisible = false;
            self.dialogLoading = true;
            let params = {
                frequency: self.selectFrequency,
                subscription: self.emailsParagraph,
                riskExcelChangedOnly: self.radioRiskExcelChangedOnly,
                companyRiskAlertAvailable: self.companyRiskAlertAvailable,
                threeDimensions: self.radioThreeDimensions,
                highestRisk: self.radioHighestRisk,
                endFund: self.radioRemoveEndFund
            };
            self.editConfig(params);
        },
        handleRiskCompanyAlert() {
            const self = this;
            self.notificationVisible = false;
            let params = {
                companyRiskAlertAvailable: self.companyRiskAlertAvailable,
            };
            self.editConfig(params);
        },
        editConfig(params) {
            const self = this;
            editSubscription(params)
            .then((response) => {
                let result = response.data;
                if (result == undefined) {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000,
                    });
                    Message.close = function() {};
                } else {
                    if (checkResponseStatus(result, self)) {

                        let userInfo = JSON.parse(getNameAndValue("info"));
                        userInfo.threeDimensions = params.threeDimensions;                                                
                        userInfo.highestRisk = params.highestRisk;

                        setNameAndValue("info", userInfo);
                        self.showingThreeDimensions = params.threeDimensions;                       
                        self.showingHighestRisk = params.highestRisk;

                        self.loadingData();

                        Message({
                            message: "设置成功",
                            type: "success",
                            duration: 2 * 1000,
                        });
                        Message.close = function() {
                            // self.loadingData();
                        };
                    }
                }
            })
            .catch((err) => {
                Message({
                    message: "数据异常，请尝试刷新再试！",
                    type: "error",
                    duration: 2 * 1000,
                });
                Message.close = function() {};
            })
            .finally((r) => {
                self.configResendNeeded = true;
                self.dialogLoading = false;
            });
        },
        handleRemoveEmail(emailInput) {
            const self = this;
            let index = self.emailsParagraph.indexOf(emailInput);
            if (index != -1) self.emailsParagraph.splice(index, 1);

            self.$refs.scrollbar.update();
        },
        handleRemoveEmailMonthly(emailInput) {
            const self = this;
            let index = self.emailsParagraphMonthly.indexOf(emailInput);
            if (index != -1) self.emailsParagraphMonthly.splice(index, 1);

            self.$refs.scrollbarMonthly.update();
        },
        handleAddEmail(emailInput) {
            const self = this;
            if (emailInput) {
                var reg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
                if (reg.test(emailInput)) {
                    if (self.emailsParagraph === null) {
                        self.emailsParagraph = [];
                    }
                    self.emailsParagraph.push(emailInput);
                    self.emailInput = "";
                    self.$refs.scrollbar.update();
                } else {
                    Message({
                        message: "邮箱格式不正确",
                        type: "error",
                        duration: 5 * 1000,
                    });
                    Message.close = function() {
                        //self.loadInfoData();
                    };
                }
            }
        },
        handleAddEmailMonthly(emailInput) {
            const self = this;
            if (emailInput) {
                var reg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
                if (reg.test(emailInput)) {
                    if (self.emailsParagraphMonthly === null) {
                        self.emailsParagraphMonthly = [];
                    }
                    self.emailsParagraphMonthly.push(emailInput);
                    self.emailInput = "";
                    self.$refs.scrollbarMonthly.update();
                } else {
                    Message({
                        message: "邮箱格式不正确",
                        type: "error",
                        duration: 5 * 1000,
                    });
                    Message.close = function() {
                        //self.loadInfoData();
                    };
                }
            }
        },
        handleSendFrequencyReportByEmail() {
            const self = this;
            self.dialogLoading = true;
            self.handleConfigFrequency();
            sendAllReportByEmail()
                .then((response) => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000,
                        });
                    } else {
                        if (checkResponseStatus(result, self)) {
                            Message({
                                message: "定时任务已启动，请半小时后查看邮箱",
                                type: "success",
                                duration: 5 * 1000,
                            });
                            Message.close = function() {
                                //self.loadInfoData();
                            };
                        }
                    }
                })
                .catch((err) => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000,
                    });
                    Message.close = function() {};
                })
                .finally((r) => {
                    self.configResendNeeded = true;
                    self.dialogLoading = false;
                });
        }
    },
};
